import {useEffect} from 'react';

// 兼容火狐浏览器 contentEditable element 粘贴的格式问题
export function useEditableElementPaste(element: HTMLElement | null) {
    useEffect(() => {
        const isFirefox = navigator.userAgent.includes('Firefox');
        // 这里监听paste事件对性能略有影响，所以只对需要的浏览器进行处理
        if (isFirefox) {
            const handlePaste = (event: HTMLElementEventMap['paste']) => {
                event.stopPropagation();
                event.preventDefault();
                const text = event.clipboardData?.getData('text/plain');
                if (document.queryCommandSupported('insertText')) {
                    document.execCommand('insertText', false, text);
                } else {
                    document.execCommand('paste', false, text);
                }
            };

            element?.addEventListener('paste', handlePaste);
            return () => {
                element?.removeEventListener('paste', handlePaste);
            };
        }
    }, [element]);
}
